var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236.27 220.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6e04d9",
    d: "M197.67 142.17c6.43-17.65 9-36.68 6.3-55.34-4.54-32-21.55-56.72-53.57-74.11-40.71-22.44-95.92-14.5-129 18.4C3.18 49.4-7.92 79.65 6.83 101c10.72 15.38 31.26 21 43.36 35.29 15.13 17.9 14 45.51 29 63.41 13.36 15.88 37.31 20.29 57 13.74 16.48-5.44 46.23-29.55 61.48-71.27Z",
    opacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b397ed",
    d: "M136.16 213.51c16.51-5.42 46.26-29.49 61.51-71.22 6.43-17.64 10-34.66 6.3-55.33-12.23-68.19-95.8 19.54-110.29 28.49-28.49 17.52-36.3 56.09-16 82.68a20.59 20.59 0 0 0 1.39 1.77c13.35 15.75 37.42 20.04 57.09 13.61Z",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7757f9",
    d: "M162.12 23.3c-17.64-6.42-36.68-9-55.33-6.3-32 4.54-56.72 21.56-74.12 53.57-22.44 40.72-14.49 95.93 18.4 129 18.28 18.28 48.53 29.37 69.84 14.62 15.37-10.71 21.05-31.26 35.29-43.36 17.9-15.13 45.5-14 63.4-29 15.88-13.36 20.29-37.31 13.74-57-5.42-16.53-29.49-46.27-71.22-61.53Z",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m125.61 158.32-16.35-33-10.9 10-5 22.94H74.78L92.65 73.9h18.76l-7 32.83 36-32.83h26L124 112.18l24.09 46.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKado);
export default __webpack_public_path__ + "static/media/Kado.666d8f952dddbf46800a56380f749fde.svg";
export { ForwardRef as ReactComponent };